<template>
  <router-view />
</template>

<style lang="scss">

@import "../node_modules/bootstrap/scss/bootstrap";
</style>
